import { render, staticRenderFns } from "./charDSJZ.vue?vue&type=template&id=11d814f4&scoped=true"
import script from "./charDSJZ.vue?vue&type=script&lang=js"
export * from "./charDSJZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d814f4",
  null
  
)

export default component.exports